<script setup>
import ListingCard from '@/components/Secondary/Marketplace/ListingCard.vue';
import { collectionV2 } from '@/composables/resource';
import { ref } from 'vue';
import SideNav from '../_helpers/layout/SideNav.vue';

const dataViewEl = ref();
const views = [
    {
        key: 'default',
        collection: collectionV2({
            url: '/api/marketplace/listings',
            params: {
                filters: {
                    saved: true,
                },
            },
        })
    }
];
</script>

<template>
    <layout-main>
        <head-title value="Saved Listings" />
        <SideNav />
        <layout-content>
            <content-header>
                <top-nav>
                    <top-nav-back />

                    <top-nav-title>Saved Listings</top-nav-title>
                    <div class="grow"></div>
                    <app-collection-query-view-trigger v-if="dataViewEl" :data-view="dataViewEl.dataView" />
                </top-nav>
            </content-header>
            <content-body>
                <div class="p-4">
                    <app-collection-view ref="dataViewEl" :views="views" v-slot="{ activeView }">
                        <ListingCard v-for="data in activeView.data" :data="data" />
                    </app-collection-view>
                </div>
            </content-body>
        </layout-content>
    </layout-main>
</template>
